import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import UploadButtons from "../../../CustomComponent/UploadButton";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import content from "./instructioncontent";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getMarkListData } from "../../../../service/MarkingServices";
import { getSlotListData } from "../../../../service/services";
import instructioncontent from "../AddExam/instructioncontent";
import instructioncontentJeeMain from "../AddExam/instructioncontentJeeMain";
import instructioncontentSsc from "../AddExam/instructioncontentSsc";
import instructioncontentIpmat from "../AddExam/instructioncontentIpmat";

const convertImageToBase64 = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

function EditExamForm() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { rowId } = useParams();

  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  function convertToHtml(languageContent) {
    let htmlContent = "";

    for (let i = 0; i < languageContent.length; i++) {
      let section = languageContent[i];
      htmlContent += `<h2>${section.superhead}</h2>`;
      htmlContent += `<h3>${section.genhead}</h3>`;
      htmlContent += `<p style="color: red;">${section.rednote}</p>`;
      htmlContent += `<p>${section.agreement}</p>`;

      for (let j = 0; j < section.gencont.length; j++) {
        let item = section.gencont[j];
        htmlContent += `<div><b>${item.id}.</b> ${item.title}`;

        if (item.children) {
          htmlContent += "<ul>";
          for (let k = 0; k < item.children.length; k++) {
            let child = item.children[k];
            htmlContent += `<li>${child.title}</li>`;
          }
          htmlContent += "</ul>";
        }

        htmlContent += "</div>";
      }
    }

    return htmlContent;
  }

  const instructionsHtml = convertToHtml(content);

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const initialData = {
    center_id: "",
    course_id: "",
    batch_ids: "",
    exam_name: "",
    language: ["en"],
    question_count: "",
    total_score: "",
    question_shuffle: "no",
    negative_marking: "no",
    is_submit_on_time: "no",
    negative_marking_score: "",
    exam_instant_result: "no",
    exam_pin: "",
    exam_instructions: {
      // en: convertToHtml(content.en),
      // hi: convertToHtml(content.hi),
      en: "",
      hi: "",
    },
    genral_instruction: {
      // en: convertToHtml(content.en),
      // hi: convertToHtml(content.hi),
      en: "",
      hi: "",
    },
    duration: "",
    start_date: "",
    start_time: "",
    end_time: "",
    slot_value: "",
    marking_system: "",
    exam_template: "",
    file: null,
    enable_submit: "0",
  };
  const [questionMarkSystem, setQuestionMarkSystem] = useState("same");
  const [formDetails, setFormDetails] = useState(initialData);
  const [examName, setExamName] = useState("");
  const [paperCode, setPaperCode] = useState("");
  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);

  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [thumbnailImagePreview, setThumbnailImagePreview] = useState(null);
  const [examTempalteData, setExamTemplateData] = useState([]);
  const [showSubjectWiseDuration, setShowSubjectWiseDuration] = useState("no");
  const [subjectDurations, setSubjectDurations] = useState([]);
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const [slotDropdownFieldData, setSlotDropdownFieldData] = useState([]);
  const [pinEnable, setPinEnable] = useState("on");

  const handleLanguageMenuToggle = () => {
    setLanguageMenuOpen(!languageMenuOpen);
  };
  console.log("subjectDurations", subjectDurations);
  const handleSubjectDurationChange = (subjectId, value) => {
    setSubjectDurations((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item.subject_id === subjectId
      );

      if (existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          duration: parseInt(value) || 0,
        };
        return updated;
      } else {
        return [
          ...prev,
          { subject_id: subjectId, duration: parseInt(value) || 0 },
        ];
      }
    });
  };
  const [perQuestionMarks, setPerQuestionMarks] = useState("0");
  useEffect(() => {
    const fetchSlots = async () => {
      try {
        if (!decryptedToken) return;
        const data = await getSlotListData();
        setSlotDropdownFieldData(data);
      } catch (err) {
        console.error("Failed to load slots", err);
      }
    };

    fetchSlots();
  }, []);
  useEffect(() => {
    const fetchSlots = async () => {
      try {
        if (!decryptedToken) return;
        const data = await getMarkListData();
        setExamTemplateData(data?.markingsystem);
      } catch (err) {
        console.error("Failed to load slots", err); // Error logging
      }
    };
    fetchSlots();
  }, []);
  useEffect(() => {
    if (formDetails.question_count && formDetails.total_score) {
      const calculatedMarks =
        formDetails.total_score / formDetails.question_count;
      setPerQuestionMarks(calculatedMarks.toFixed(2));
    }
  }, [formDetails.question_count, formDetails.total_score]);

  const isInitialRender = useRef(true);
  useEffect(() => {
    if (formDetails?.question_mark_system === "different") {
      setFormDetails((prevFormDetails) => ({
        ...prevFormDetails,
        negative_marking: "no",
      }));
    }
  }, [formDetails.question_mark_system]);
  useEffect(() => {
    const convertAllImagesToBase64 = async (htmlContent) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      const imgTags = doc.querySelectorAll("img");

      for (const img of imgTags) {
        const src = img.getAttribute("src");
        if (src && !src.startsWith("data:")) {
          const base64 = await convertImageToBase64(src);
          img.setAttribute("src", base64);
        }
      }

      return doc.body.innerHTML;
    };

    const handleInstructions = async () => {
      if (!formDetails.exam_template) return;

      let selectedInstructions;
      switch (formDetails.exam_template.toLowerCase()) {
        case "iit":
          selectedInstructions = {
            en: instructioncontentJeeMain.en,
            hi: instructioncontentJeeMain.hi,
          };
          break;
        case "ssc/railway":
          selectedInstructions = {
            en: instructioncontentSsc.en,
            hi: instructioncontentSsc.hi,
          };
          break;
        case "ipmat":
          selectedInstructions = {
            en: instructioncontentIpmat.en,
            hi: instructioncontentIpmat.hi,
          };
          break;
        default:
          selectedInstructions = {
            en: instructioncontent.en,
            hi: instructioncontent.hi,
          };
      }

      const [en, hi] = await Promise.all([
        convertAllImagesToBase64(selectedInstructions.en),
        convertAllImagesToBase64(selectedInstructions.hi),
      ]);
      // setFormDetails((prev) => ({
      //   ...prev,
      //   exam_instructions: { en, hi },
      // }));

      setFormDetails((prev) => {
        if (isInitialRender.current) {
          return prev;
        }
        return {
          ...prev,
          exam_instructions: { en, hi },
        };
      });
      isInitialRender.current = false;
      // },
    };

    handleInstructions();
  }, [formDetails.exam_template]);

  const handleQuestionMarkSystemChange = (event) => {
    setShowSubjectWiseDuration(event.target.value);
  };

  const quillModules = {
    toolbar: [
      [
        "bold",
        "italic",
        "underline",
        "strike",
        { script: "sub" },
        { script: "super" },
        { color: [] },
        { background: [] },
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["code-block"],
    ],
  };

  const quillFormats = [
    "header",
    "font",
    "size",
    "list",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "link",
    "blockquote",
    "code-block",
    "align",
    "image",
  ];

  function isDecimal(num) {
    const decimal = num % 1;
    return decimal !== 0;
  }
  const handleFormChange = (fieldName, value) => {
    if (fieldName === "language") {
      const newInstructions = { ...formDetails.exam_instructions };
      const newGenralInstructions = { ...formDetails.genral_instruction };
      (typeof value === "string" ? value.split(",") : value).forEach((lang) => {
        if (!newInstructions[lang]) {
          newInstructions[lang] = "";
        }
      });
      setFormDetails((prevFormDetails) => ({
        ...prevFormDetails,
        [fieldName]: typeof value === "string" ? value.split(",") : value,
        exam_instructions: newInstructions,
        genral_instruction: newGenralInstructions,
      }));
    } else {
      setFormDetails((prevFormDetails) => ({
        ...prevFormDetails,
        [fieldName]: value,
      }));
    }
  };

  const handleThumbnailImageChange = (image) => {
    setThumbnailImage(image);
  };

  const handleCourceChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  const handleBatchChange = (event) => {
    setSelectedBatch(event.target.value);
  };

  const handleSubjectChange = (event, newValue) => {
    setSelectedSubject(newValue.map((subject) => subject.id));
  };

  const handleCenterChange = (event, newValue) => {
    setSelectedCenter(newValue.map((center) => center.id));
  };

  const handleCancel = () => {
    navigate("/admin/exam");
  };
  console.log(
    "selectedSubject",
    selectedSubject,
    selectedBatch,
    batches?.length,
    subjects?.length
  );
  // useEffect(()=>{

  // },[])
  const handleFormSubmit = async () => {
    if (!examName.trim()) {
      toast.warn("Please enter an exam name.");
      return;
    }

    if (!selectedCourse) {
      toast.warn("Please select a course.");
      return;
    }

    if (!selectedBatch || batches?.length === 0) {
      toast.warn("Please select a batch.");
      return;
    }

    if (
      !selectedSubject ||
      selectedSubject.length === 0 ||
      subjects?.length === 0
    ) {
      toast.warn("Please select at least one subject.");
      return;
    }

    if (!formDetails.language || formDetails.language.length === 0) {
      toast.warn("Please select at least one language.");
      return;
    }

    if (!formDetails.question_count) {
      toast.warn("Please enter the number of questions.");
      return;
    }

    if (!formDetails.total_score) {
      toast.warn("Please enter the total score.");
      return;
    }
    if (showSubjectWiseDuration === "yes") {
      // Check if durations are provided for all selected subjects
      if (subjectDurations.length !== selectedSubject.length) {
        toast.warn("Please enter duration for all selected subjects.");
        return;
      }

      // Check each subject duration
      const invalidSubjects = [];
      subjectDurations.forEach((item) => {
        if (isNaN(item.duration) || item.duration <= 0) {
          const subject = subjects.find((sub) => sub.id === item.subject_id);
          if (subject) invalidSubjects.push(subject.subject_name);
        }
      });

      if (invalidSubjects.length > 0) {
        toast.warn(
          `Please enter valid duration for: ${invalidSubjects.join(", ")}`
        );
        return;
      }
    }
    if (
      formDetails.negative_marking == "yes" &&
      (formDetails.negative_marking_score.length === 0 ||
        formDetails.negative_marking_score == -0)
    ) {
      if (formDetails.negative_marking_score == -0) {
        toast.warn("Please Add a Negetive Marking Grater Then 0.");
      } else {
        toast.warn("Please Add a Negetive Marking.");
      }
      return;
    }
    if (!formDetails.exam_pin && pinEnable === "on") {
      toast.warn("Please enter the exam pin.");
      return;
    }

    if (!formDetails.duration) {
      toast.warn("Please enter the duration of the exam.");
      return;
    }
    if (!selectedCenter || selectedCenter.length === 0) {
      toast.warn("Please select at least one center.");
      return;
    }
    if (!formDetails.exam_template) {
      toast.warn("Please select a Exam Template.");
      return;
    }
    // if (!formDetails.slot_value) {
    //   toast.warn("Please select a Exam Template.");
    //   return;
    // }
    if (!formDetails.start_date) {
      toast.warn("Please select a start date.");
      return;
    }
    if (!formDetails.start_time) {
      toast.warn("Please select a start time.");
      return;
    }
    if (!formDetails.end_time) {
      toast.warn("Please select a end time.");
      return;
    }

    if (questionMarkSystem === "same" && isDecimal(perQuestionMarks)) {
      toast.warn("Per Question Mark must be a whole number.");
      return;
    }
    // if (!formDetails.slot_value) {
    //   toast.warn("Please select a Slot.");
    //   return;
    // }
    try {
      const formData = new FormData();
      const examData = {
        id: rowId,
        center_id: selectedCenter,
        course_ids: selectedCourse,
        batch_ids: selectedBatch,
        subjects: selectedSubject,
        exam_name: examName,
        paper_code: paperCode,
        language: formDetails.language.map((lang) =>
          lang === "en" ? "en" : "hi"
        ),
        question_count: formDetails.question_count,
        total_score: formDetails.total_score,
        per_question_mark: perQuestionMarks,
        question_shuffle: formDetails.question_shuffle,
        negative_marking: formDetails.negative_marking,
        negative_marking_score: `-${Math.abs(
          formDetails.negative_marking_score
        )}`,
        exam_instant_result: formDetails.exam_instant_result,
        exam_pin: formDetails.exam_pin,
        exam_instruction_en: formDetails.exam_instructions.en,
        exam_instruction_hi: formDetails.exam_instructions.hi,
        enable_submit: formDetails.enable_submit || "0",
        genral_instruction_en: formDetails.genral_instruction.en,
        genral_instruction_hi: formDetails.genral_instruction.hi,
        duration: formDetails.duration,
        start_date: formDetails.start_date,
        start_time: formDetails.start_time,
        is_submit_on_time: formDetails.is_submit_on_time,
        end_time: formDetails.end_time,
        slot_id: formDetails.slot_value || null,
        marking_system_id: formDetails.marking_system || null,
        exam_template: formDetails.exam_template,
        subject_wise: showSubjectWiseDuration || null,
        marking_system_id: formDetails.marking_system || null,
        question_mark_system: questionMarkSystem || null,
        subjectDuration:
          showSubjectWiseDuration === "yes" ? subjectDurations : [],
        exam_type: "main",
        pin_enable: pinEnable,
      };

      formData.append("exam", JSON.stringify(examData));
      formData.append("file", thumbnailImage);
      console.log(examData, "examData");
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Exam updated successfully!");

        setTimeout(() => {
          navigate(`/admin/addquestion/${response.data.exam.id}`);
        }, 2000);
      } else {
        toast.error(`Exam is not updated! ${response.data.message}`);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error(error.response.data.message);
      // toast.error("Exam is not updated!");
    }
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/all/active`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );

        // Ensure that the API response contains the 'batch' property
        if (response.data && response.data.courses) {
          setCourses(response.data.courses);
        } else {
          console.error("Invalid API response format:", response);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, [decryptedToken]);

  const fetchBatches = async (selectedCourse) => {
    const data = {
      batch: {
        course_ids: selectedCourse,
      },
    };

    try {
      const response = await axios.post(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_id/${selectedCourse}`,
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_ids/list`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (response) {
        console.log("selectedCourse", response.data.batches);
        setBatches(response.data.batches);
      } else {
        console.error("Failed to fetch batches data:", response);
      }

      // if (response.data && response.data.batches) {
      //   setBatches(response.data.batches);
      // } else {
      //   console.error("Invalid API response format:", response);
      // }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  useEffect(() => {
    fetchBatches(selectedCourse);
  }, [selectedCourse]);

  const fetchSubjects = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (response.data && response.data.subjects) {
        setSubjects(response.data.subjects);
      } else {
        console.error("Invalid API response format:", response);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchCenter = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      // Ensure selectedCourses is not empty before making the request
      if (selectedCourse && selectedBatch) {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course/batch`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              center: {
                courseId: selectedCourse,
                batchId: selectedBatch,
              },
            }),
          }
        );
        if (response.ok) {
          const data = await response.json();
          setCenter(data.response);
        } else {
          console.error("Failed to fetch batches data:", response);
        }
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchCenter();
  }, [selectedCourse, selectedBatch]);

  function formatTime(timeString) {
    // Extract hours and minutes from the time string
    const [hours, minutes] = timeString.split(":");
    return `${hours}:${minutes}`;
  }
  const cleanHTML = (html) => {
    if (!html) return html;
    return html
      .replace(/<p[^>]*>\s*(<br[^>]*>)?\s*<\/p>/gi, "")
      .replace(/(<[^>]+>)\s+(?=<)/g, "$1")
      .replace(/(>)\s+(<)/g, "$1$2")
      .replace(/\s{2,}/g, " ")
      .replace(/&nbsp;/g, " ")
      .trim();
  };
  const normalizeQuillHTML = (html) => {
    if (!html) return html;
    return html
      .replace(/<p[^>]*>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi, "")
      .replace(/<p[^>]*>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ol>)/gi, "")
      .replace(/(<\/li>)\s*<p[^>]*>(\s*)<\/p>/gi, "$1")
      .replace(/<p>\s*<br>\s*<\/p>/gi, "");
  };
  const fetchDataFromAPI = async (rowId) => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.status === 200 && response.data.success) {
        const exam = response.data.exam;

        // Convert the incoming date string to a Date object
        const incomingDate = new Date(exam.start_date);

        // incomingDate.setDate(incomingDate.getDate() + 1);
        incomingDate.setDate(incomingDate.getDate());

        // Format the date to 'YYYY-MM-DD' string
        const startDate = incomingDate.toISOString().split("T")[0];
        const startTime = formatTime(exam.start_time);
        const endTime = exam.end_time ? formatTime(exam.end_time) : null;

        setFormDetails({
          ...formDetails,
          center_id: exam.center_id,
          slot_value: exam.slot_id,
          marking_system: exam.marking_system_id,
          course_id: exam.course,
          batch_ids: exam.batch,
          exam_name: exam.exam_name,
          language: exam.language.map((lang) => lang.code || lang),
          question_count: exam.question_count,
          per_question_mark: perQuestionMarks,
          total_score: exam.total_score,
          is_submit_on_time: exam.is_submit_on_time === true ? "yes" : "no",
          question_shuffle: exam.question_shuffle,
          negative_marking: exam.negative_marking,
          negative_marking_score: exam.negative_marking_score.toString(),
          exam_instant_result: exam.exam_instant_result,
          exam_pin: exam.exam_pin,
          enable_submit: exam.enable_submit || "0",
          exam_instructions: {
            // en: exam.exam_instruction_en.replace(
            //   /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
            //   ""
            // ),
            // hi: exam.exam_instruction_hi.replace(
            //   /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
            //   ""
            // ),
            en: cleanHTML(normalizeQuillHTML(exam.exam_instruction_en)),
            hi: cleanHTML(normalizeQuillHTML(exam.exam_instruction_hi)),
          },
          genral_instruction: {
            en: cleanHTML(normalizeQuillHTML(exam.genral_instruction_en)),
            hi: cleanHTML(normalizeQuillHTML(exam.genral_instruction_hi)),
            // en: exam.genral_instruction_en.replace(
            //   /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
            //   ""
            // ),
            // hi: exam.genral_instruction_hi.replace(
            //   /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
            //   ""
            // ),
          },
          duration: exam.duration,
          start_date: startDate,
          start_time: startTime,
          end_time: endTime,
          // marking_system:marking_system,
          exam_template: exam.exam_template,
        });
        setSelectedCourse(exam.course.map((c) => c.id));
        setPerQuestionMarks(exam.per_question_mark);
        setSelectedBatch(exam.batch.map((b) => b.id));
        setExamName(exam.exam_name);
        setPaperCode(exam.paper_code);
        setSelectedSubject(exam.subjects.map((subject) => subject.id));
        setSelectedCenter(exam.center.map((center) => center.id));
        setThumbnailImage(exam.image_url);
        setThumbnailImagePreview(exam.image_url);
        setQuestionMarkSystem(exam.question_mark_system);
        setShowSubjectWiseDuration(exam.subject_wise);
        setSubjectDurations(exam.subjectduration);
        setPinEnable(exam?.pin_enable || "on");
      } else {
        toast.error("Failed to fetch exam details.");
      }
    } catch (error) {
      console.error("Error fetching data from the API:", error);
      toast.error("An error occurred while fetching exam details.");
    }
  };
  const initialDataLoaded = useRef(false);
  useEffect(() => {
    if (rowId) {
      fetchDataFromAPI(rowId).then(() => {
        initialDataLoaded.current = true; // Mark initial load complete
      });
    }
  }, [rowId]);


  const [loading, setLoading] = useState(false);

  const handleAutoGeneratePin = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/generate/unique/pin`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      handleFormChange("exam_pin", res.data?.exam_pin);
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate exam pin");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1}  ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h72vh}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Exam Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  required
                  onChange={(e) => setExamName(e.target.value)}
                  value={examName}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Paper Code
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  required
                  onChange={(e) => setPaperCode(e.target.value)}
                  value={paperCode}
                  placeholder="Type Here"
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="courses-multiple"
                  options={courses}
                  getOptionLabel={(option) => option.course_name}
                  value={courses.filter((c) => selectedCourse.includes(c.id))}
                  onChange={(event, newValue) =>
                    setSelectedCourse(newValue.map((c) => c.id))
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="courses"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batch <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="batches-multiple"
                  options={batches}
                  getOptionLabel={(option) => option.batch_name}
                  value={batches.filter((b) => selectedBatch.includes(b.id))}
                  onChange={(event, newValue) =>
                    setSelectedBatch(newValue.map((b) => b.id))
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="batches"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Subject <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={subjects}
                  getOptionLabel={(option) => option.subject_name}
                  value={subjects.filter((sub) =>
                    selectedSubject.includes(sub.id)
                  )}
                  onChange={handleSubjectChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
                   ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Code <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={center}
                  getOptionLabel={(option) =>
                    `${option.center_code} - ${option.center_name}`
                  }
                  value={center?.filter((sub) =>
                    selectedCenter?.includes(sub.id)
                  )}
                  onChange={handleCenterChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
              </div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Languages <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="language-label"
                  id="language"
                  multiple
                  open={languageMenuOpen}
                  onOpen={handleLanguageMenuToggle}
                  onClose={handleLanguageMenuToggle}
                  value={formDetails.language}
                  onChange={(e) => {
                    handleFormChange("language", e.target.value);
                    handleLanguageMenuToggle(); // Close the dropdown after selection
                  }}
                  renderValue={(selected) =>
                    selected
                      .map((code) => (code === "en" ? "English" : "Hindi"))
                      .join(", ")
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem value="hi">Hindi</MenuItem>
                  <MenuItem value="en">English</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Template <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Select
                  labelId="category-label"
                  id="state"
                  required
                  value={formDetails.exam_template}
                  onChange={(e) =>
                    handleFormChange("exam_template", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>

                  <MenuItem value={"default"}>Default</MenuItem>
                  <MenuItem value={"ssc/railway"}>IIT</MenuItem>
                  <MenuItem value={"ipmat"}>IP MAT</MenuItem>
                  {/* <MenuItem value={"cat"}>Banking</MenuItem> */}
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Question Shuffle{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="shuffle-label"
                  id="shuffle"
                  value={formDetails.question_shuffle}
                  onChange={(e) =>
                    handleFormChange("question_shuffle", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Marking System{" "}
                  {/* <span className={classes.textcolorred}>*</span> */}
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="state"
                  required
                  value={formDetails.marking_system}
                  onChange={(e) =>
                    handleFormChange("marking_system", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem value="">Select a slot</MenuItem>
                  {examTempalteData?.map((slot, index) => (
                    <MenuItem key={index} value={slot?.id}>
                      {slot?.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              {/* <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Parcial Marking{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
    
                    <TextField
                      type="number"
                      variant="outlined"
                      onChange={(e) =>
                        handleFormChange("parcial_marking", e.target.value)
                      }
                      value={formDetails.parcial_marking}
                      placeholder="Type Here"
                    />
                  </div> */}
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Question Count <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <TextField
                  type="number"
                  variant="outlined"
                  onChange={(e) =>
                    handleFormChange("question_count", e.target.value)
                  }
                  value={formDetails.question_count}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Total Score <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  onChange={(e) =>
                    handleFormChange("total_score", e.target.value)
                  }
                  value={formDetails.total_score}
                  placeholder="Type Here"
                />
              </div>
            </div>

            <div
              className={` ${classes.w100} ${classes.justifyspacebetween} ${classes.dflex}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div className={`${classes.w75}`}>
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Per Question Mark
                    </FormLabel>
                    <TextField
                      type="text"
                      variant="outlined"
                      value={
                        perQuestionMarks ? `${perQuestionMarks} marks` : "N/A"
                      }
                      disabled
                    />
                  </div>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Question Mark System{" "}
                      {console.log("question_mark_system", formDetails)}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={questionMarkSystem}
                      onChange={(e) =>
                        handleFormChange("question_mark_system", e.target.value)
                      }
                    >
                      <FormControlLabel
                        value="same"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("same")}
                          />
                        }
                        label="Same"
                      />
                      <FormControlLabel
                        value="different"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("different")}
                          />
                        }
                        label="Different"
                      />
                    </RadioGroup>
                  </div>
                  {questionMarkSystem === "same" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <Select
                        labelId="negativemarking-label"
                        id="negativemarking"
                        value={formDetails.negative_marking}
                        onChange={(e) =>
                          handleFormChange("negative_marking", e.target.value)
                        }
                        displayEmpty
                        className={classes.selectEmpty}
                        MenuProps={menuProps}
                        variant="outlined"
                      >
                        <MenuItem disabled value="">
                          <em className={classes.defaultselect}>Select Here</em>
                        </MenuItem>
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                      </Select>
                    </div>
                  )}
                  {questionMarkSystem === "different" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <Select
                        labelId="negativemarking-label"
                        id="negativemarking"
                        value="no"
                        onChange={(e) =>
                          handleFormChange("negative_marking", e.target.value)
                        }
                        displayEmpty
                        className={classes.selectEmpty}
                        MenuProps={menuProps}
                        variant="outlined"
                        disabled
                      >
                        <MenuItem disabled value="">
                          <em className={classes.defaultselect}>Select Here</em>
                        </MenuItem>
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                      </Select>
                    </div>
                  )}

                  {/* {formDetails.negative_marking === "yes" && (
                        <div
                          className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w49}`}
                        >
                          <FormLabel
                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                          >
                            Negative Marking Score
                            <span className={classes.textcolorred}>*</span>
                          </FormLabel>
                          <TextField
                            type="float"
                            variant="outlined"
                            required
                            value={
                              questionMarkSystem === "different"
                                ? 0
                                : formDetails.negative_marking_score
                            }
                            onChange={(e) =>
                              handleFormChange(
                                "negative_marking_score",
                                e.target.value
                              )
                            }
                            placeholder="Type Here"
                            disabled={questionMarkSystem === "different"}
                          />
                        </div>
                      )}
    
                      {formDetails.negative_marking === "no" && (
                        <div
                          className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w49}`}
                        >
                          <FormLabel
                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                          >
                            Negative Marking Score{" "}
                            <span className={classes.textcolorred}>*</span>
                          </FormLabel>
                          <TextField
                            type="number"
                            variant="outlined"
                            required
                            value={formDetails.negative_marking_score}
                            onChange={(e) =>
                              handleFormChange(
                                "negative_marking_score",
                                e.target.value
                              )
                            }
                            placeholder="Type Here"
                            disabled
                          />
                        </div>
                      )} */}
                </div>
              </div>
            </div>

            {formDetails.exam_template === "ipmat" && (
              <div
                className={`${classes.dflex} ${classes.w100} ${classes.justifyspacebetween} ${classes.mt1} `}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div
                  className={`${classes.dflex} ${classes.flexwrapwrap}  ${classes.w75}  ${classes.gap10}`}
                >
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Subject Wise Submit{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={showSubjectWiseDuration}
                      onChange={handleQuestionMarkSystemChange}
                    >
                      <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label="No"
                      />
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Yes"
                      />
                    </RadioGroup>
                  </div>

                  {showSubjectWiseDuration === "yes" &&
                    subjects
                      .filter((sub) => selectedSubject.includes(sub.id))
                      .map((sub) => (
                        <div
                          key={sub.id}
                          className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w32}`}
                        >
                          <FormLabel
                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                          >
                            {sub.subject_name} Duration{" "}
                            <span className={classes.textcolorred}>*</span>
                          </FormLabel>
                          <TextField
                            type="number"
                            variant="outlined"
                            value={
                              subjectDurations.find(
                                (item) => item.subject_id === sub.id
                              )?.duration ?? "0"
                            }
                            onChange={(e) =>
                              handleSubjectDurationChange(
                                sub.id,
                                e.target.value
                              )
                            }
                            placeholder="Type Here"
                          />
                        </div>
                      ))}
                </div>
              </div>
            )}

            <div
              className={` ${classes.w100} ${classes.justifyspacebetween} ${classes.dflex}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div className={`${classes.w75}`}>
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  {questionMarkSystem === "same" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking Score
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <TextField
                        type="float"
                        variant="outlined"
                        required
                        value={
                          formDetails.negative_marking === "no"
                            ? 0
                            : `-${String(
                              formDetails.negative_marking_score
                            ).replace(/^[-]+/, "")}`
                        }
                        onChange={(e) => {
                          let value = e.target.value.replace(/[^0-9.]/g, "");

                          if (formDetails.negative_marking === "yes") {
                            handleFormChange("negative_marking_score", value);
                          } else {
                            handleFormChange("negative_marking_score", "0");
                          }
                        }}
                        placeholder="Type Here"
                        disabled={formDetails.negative_marking === "no"}
                      />
                    </div>
                  )}
                  {questionMarkSystem === "different" && (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Negative Marking Score{" "}
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <TextField
                        type="number"
                        variant="outlined"
                        required
                        value={
                          questionMarkSystem === "different"
                            ? 0
                            : questionMarkSystem
                        }
                        onChange={(e) =>
                          handleFormChange(
                            "negative_marking_score",
                            e.target.value
                          )
                        }
                        placeholder="Type Here"
                        disabled
                      />
                    </div>
                  )}
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Exam Instant Result{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="exam-instant-result-label"
                      id="exam-instant-result"
                      value={formDetails.exam_instant_result}
                      onChange={(e) =>
                        handleFormChange("exam_instant_result", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>

                      <MenuItem value={"no"}>No</MenuItem>
                      <MenuItem value={"with_answer"}>With Answers</MenuItem>
                      <MenuItem value={"without_answer"}>
                        Without Answers
                      </MenuItem>
                      {/* <MenuItem value={"section_wise"}>
                            Section Wise Result
                          </MenuItem> */}
                    </Select>
                  </div>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Exam PIN Enable
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="PIN Enable"
                      name="PIN Enable"
                      value={pinEnable}
                      onChange={(e) => setPinEnable(e.target.value)}
                    >
                      <FormControlLabel
                        value="on"
                        control={<Radio />}
                        label="On"
                      />
                      <FormControlLabel
                        value="off"
                        control={<Radio />}
                        label="Off"
                      />
                    </RadioGroup>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={` ${classes.w100} ${classes.justifyspacebetween} ${classes.dflex} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div className={`${classes.w75}`}>
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >


                  {pinEnable === "on" && (
                    <>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Exam PIN <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="text"
                          variant="outlined"
                          required
                          placeholder="****"
                          disabled={pinEnable === "off"}
                          value={formDetails.exam_pin}
                          onChange={(e) => handleFormChange("exam_pin", e.target.value)}
                          inputProps={{ maxLength: 4 }}
                          error={formDetails.exam_pin.length !== 4}
                          helperText={
                            formDetails.exam_pin.length !== 4
                              ? "Exam PIN must be exactly 4 digits"
                              : ""
                          }
                        />
                      </div>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.mt1_5} ${classes.w32}`}
                      >
                        <Button
                          onClick={handleAutoGeneratePin}
                          className={classes.custombtnblue}
                          disabled={loading}
                        >
                          {loading ? "Generating..." : "Auto Generate"}
                        </Button>
                      </div>
                    </>
                  )}

                  {(formDetails.exam_template === "ipmat") ? (
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                    >

                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Submit On Time{" "}
                        <span className={classes.textcolorred}>*</span>
                      </FormLabel>
                      <Select
                        labelId="shuffle-label"
                        id="shuffle"
                        value={formDetails.is_submit_on_time}
                        onChange={(e) =>
                          handleFormChange("is_submit_on_time", e.target.value)
                        }
                        displayEmpty
                        className={classes.selectEmpty}
                        MenuProps={menuProps}
                        variant="outlined"
                      >
                        <MenuItem disabled value="">
                          <em className={classes.defaultselect}>Select Here</em>
                        </MenuItem>
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                      </Select>

                    </div>

                  ) :
                    (
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.mt1_5} ${classes.w32}`}
                      >
                      </div>
                    )}


                </div>
              </div>
            </div>

            {/* {formDetails.exam_template === "ssc/railway" && (
                  <div
                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
                  >
                    <Typography
                      className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                      variant="h6"
                      display="inline"
                    ></Typography>
                    <div
                      className={`${classes.dflex} ${classes.flexwrapwrap}  ${classes.w75}  ${classes.gap10}`}
                    >
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w32}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Subject Wise Submit{" "}
                          <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <RadioGroup
                          className={`${classes.radiocolor}`}
                          row
                          aria-label="Question Mark System"
                          name="Question Mark System"
                          value={showSubjectWiseDuration}
                          onChange={handleQuestionMarkSystemChange}
                        >
                          <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="No"
                          />
                          <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label="Yes"
                          />
                        </RadioGroup>
                      </div>
    
                      {showSubjectWiseDuration === "yes" &&
                        subjects
                          .filter((sub) => selectedSubject.includes(sub.id))
                          .map((sub) => (
                            <div
                              key={sub.id}
                              className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w32}`}
                            >
                              <FormLabel
                                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                              >
                                {sub.subject_name} Duration{" "}
                                <span className={classes.textcolorred}>*</span>
                              </FormLabel>
                              <TextField
                                type="number"
                                variant="outlined"
                                value={
                                  subjectDurations.find(
                                    (item) => item.subject_id === sub.id
                                  )?.duration ?? 0
                                }
                                onChange={(e) =>
                                  handleSubjectDurationChange(
                                    sub.id,
                                    e.target.value
                                  )
                                }
                                placeholder="Type Here"
                              />
                            </div>
                          ))}
                    </div>
                  </div>
                )} */}

            <div
              className={`${classes.dflex} ${classes.mt2}  ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
              >
                {formDetails.language.map((lang) => (
                  <div key={lang}>
                    <FormLabel>
                      {/* Enter your Genral Instructions for {lang} language: */}
                      Enter your Exam Instructions for {lang} language:
                    </FormLabel>
                    <ReactQuill
                      style={{
                        height: "500px",
                        paddingTop: "1rem",
                        paddingBottom: "3rem",
                      }}
                      value={formDetails.genral_instruction[lang]}
                      onChange={(content) => {
                        setFormDetails((prev) => ({
                          ...prev,
                          genral_instruction: {
                            ...prev.genral_instruction,
                            [lang]: content,
                          },
                        }));
                      }}
                      modules={quillModules}
                      formats={quillFormats}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.mt2}  ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
              >
                {formDetails.language.map((lang) => (
                  <div key={lang}>
                    <FormLabel>
                      {/* Enter your Exam Instructions for {lang} language: */}
                      Enter your Genral Instructions for {lang} language:
                    </FormLabel>
                    <ReactQuill
                      // readOnly
                      value={formDetails.exam_instructions[lang]}
                      onChange={(content) => {
                        setFormDetails((prev) => ({
                          ...prev,
                          exam_instructions: {
                            ...prev.exam_instructions,
                            [lang]: content,
                          },
                        }));
                      }}
                      readOnly={true}
                      // modules={quillModules}
                      modules={{
                        ...quillModules,
                        toolbar: {
                          ...quillModules.toolbar,
                          container: quillModules.toolbar?.container,
                          handlers: {}, // override all handlers so nothing works
                        },
                      }}
                      formats={quillFormats}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                *Other Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Duration in minutes{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  required
                  value={formDetails.duration}
                  onChange={(e) => handleFormChange("duration", e.target.value)}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Enable submit in minutes{" "}
                  {/* <span className={classes.textcolorred}>*</span> */}
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  required
                  value={formDetails.enable_submit}
                  onChange={(e) =>
                    handleFormChange("enable_submit", e.target.value)
                  }
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Start Date <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="date"
                  variant="outlined"
                  required
                  value={formDetails.start_date}
                  onChange={(e) =>
                    handleFormChange("start_date", e.target.value)
                  }
                  placeholder="Select Date"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Start Time <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="time"
                  variant="outlined"
                  required
                  value={formDetails.start_time}
                  onChange={(e) =>
                    handleFormChange("start_time", e.target.value)
                  }
                  placeholder="Type Here"
                />
              </div>

              {/* <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}
                  > */}
              {/* <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Select Slot
                    </FormLabel>
                    <Select
                      value={formDetails.slot_value}
                      onChange={(e) =>
                        handleFormChange("slot_value", e.target.value)
                      }
                      displayEmpty
                      required
                      variant="outlined"
                    >
                      <MenuItem value="">Select a slot</MenuItem>
                      {slotDropdownFieldData?.centers_slot?.map((slot, index) => (
                        <MenuItem key={index} value={slot?.id}>
                          {slot?.slot_name}
                        </MenuItem>
                      ))}
                    </Select> */}
              {/* </div> */}
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                {/* *Other Details */}
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  End Time <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="time"
                  variant="outlined"
                  required
                  value={formDetails.end_time}
                  onChange={(e) => handleFormChange("end_time", e.target.value)}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              ></div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              ></div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w18}`}
              ></div>
            </div>

            {/* <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Select Slot <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      value={formDetails.slot_value}
                      onChange={(e) =>
                        handleFormChange("slot_value", e.target.value)
                      }
                      displayEmpty
                      required
                      variant="outlined"
                    >
                      <MenuItem value="" disabled>
                        Select a slot
                      </MenuItem>
                      {slotDropdownFieldData?.centers_slot?.map((slot, index) => (
                        <MenuItem key={index} value={slot?.id}>
                          {slot?.slot_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  ></div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  ></div>
                </div> */}
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              onClick={handleCancel}
              className={`${classes.custombtnoutline}`}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default EditExamForm;
